import { Injectable, HostListener } from '@angular/core';
import { Routes } from '@angular/router';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';
import { DASHBOARD_ROUTES } from '../components/layout/full-layout/components.routes';

// Menu
export interface Menu {
	path?: string;
	title?: string;
	headerTitle: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	children?: Menu[];
	claimType: string;


}

@Injectable({
	providedIn: 'root'
})

export class NavService {

	public screenWidth: any
	public collapseSidebar: boolean = false
	public fullScreen = false;
	MENUITEMS: Menu[] = [];
	private _items = new BehaviorSubject<Menu[]>([]);
	public items = this._items; 
	constructor() {
		this.onResize();
		if (this.screenWidth < 991) {
			this.collapseSidebar = true
		}
		this.MENUITEMS = this.convertRoutesToMenu(DASHBOARD_ROUTES);
		this._items.next(this.MENUITEMS);
		
	}
	// private convertRoutesToMenu(routes: Routes): Menu[] {
	// 	return routes.map(route => ({
	// 	  path: route.path,
	// 	  title: route.data?.['breadcrumb'] || 'No Title', // Use breadcrumb as title
	// 	  claimType: route.data?.['claimType'],  // Capture claimType for authorization
	// 	  icon: route.data?.['icon'],  // Default icon, can modify as needed
	// 	  type: route.data?.['type'],
	// 	  active: route.data?.['active'],  // Assuming 'link' type for all items
	// 	  children: route.children ? this.convertRoutesToMenu(route.children) : [] // Handle nested routes
	// 	}));
	//   }
	private convertRoutesToMenu(routes: Routes): Menu[] {
		return routes.map(route => {
		  const menuItem: Menu = {
			path: route.path || '',  // Use empty string for parent routes
			title: route.data?.['title'] || 'No Title',
			headerTitle: route.data?.['headerTitle'] || 'No Title',
			claimType: route.data?.['claimType'],
			icon: route.data?.['icon'],
			type: route.data?.['type'],
			active: route.data?.['active'] || false,
			children: route.children ? this.convertRoutesToMenu(route.children) : []  // Process children recursively
		  };
		  return menuItem;
		});
	  }
	  
	// Windows width
	@HostListener('window:resize', ['$event'])
	onResize(event?:any) {
		this.screenWidth = window.innerWidth;
	}

}
